<div class="logo" [ngClass]="{ 'logo--vertical': verticalPosition }">
  <img
    *ngIf="company.placeInformation.logo"
    [src]="baseUrl + company.placeInformation.logo"
  />
  <span>{{ company.companyName }}</span>
</div>
